<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <date-format-select
        @changeDateFormatData="changeDateFormatData($event.dateFormatId)"
        :isMonthly="true"
      />
      <search-channel-select v-model="tableParams.channelId" />
      <search-channel-slot-select
        v-model="slotIdList"
        :channel-id="tableParams.channelId"
        multiple
      />
      <search-dsp-select v-model="tableParams.dspId" />

      <search-dsp-slot-select
        v-model="dspSlotIdList"
        :dsp-id="tableParams.dspId"
        multiple
      />

      <search-slot-type-select v-model="tableParams.slotTypeId" />
      <search-budget-type v-model="tableParams.budget" />
      <el-select
        v-model="tableParams.appType"
        clearable
        placeholder="请选择设备类型"

      >
        <el-option label="Android" :value="1"></el-option>
        <el-option label="ios " :value="2"></el-option>
        <el-option label="鸿蒙" :value="3"></el-option>
        <el-option label="其他" :value="4"></el-option>
      </el-select>
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column
        @search="searchColumn"
        @refresh="toQuery"
        @change="changeColumn"
        :column="columns"
        :hide="hides"
        table-id="channelReport"
        style="padding-bottom: 10px"
      >
        <el-button
          @click="
            downExcel('/report/appbundle/list/csv', '渠道包名报表', tableParams)
          "
          type="warning"
          size="small"
          >下载</el-button
        >
      </table-column>

      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        @sort-change="sortChange"
        :header-cell-style="{ background: '#fafafa' }"
        row-key="id"
        lazy
        :summary-method="tableSummary"
        show-summary
        highlight-current-row
        size="small"
        ref="report"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-if="
            tableParams.isDay === 1 ||
            tableParams.isHour === 1 ||
            tableParams.isMonth === 1
          "
          prop="reportTime"
          :label="
            tableParams.isDay === 1 || tableParams.isMonth === 1
              ? '日期'
              : '时间'
          "
          fixed
          sortable
          align="center"
        />
        <el-table-column
          v-for="(v, i) in checkColumns"
          align="center"
          :prop="v.field"
          :sortable="
            v.field === 'uniShowSmt' ||
            v.field === 'uniClkSmt' ||
            v.field === 'reqSmt' ||
            v.field === 'dauSlotReqSmt' ||
            v.field === 'time' ||
            v.field === 'effectiveFillingRate' ||
            v.field === 'effectiveShowRat' ||
            v.field === 'repSmt' ||
            v.field === 'showRat' ||
            v.field === 'fillingRate' ||
            v.field === 'clickRate' ||
            v.field === 'dpRate' ||
            v.field === 'dpSmt' ||
            v.field === 'resSmt' ||
            v.field === 'uniWinSmt' ||
            v.field === 'bidPrice' ||
            v.field === 'basePrice' ||
            v.field === 'bidDspPrice' ||
            v.field === 'channelEcpm' ||
            v.field === 'ecpmAverage' ||
            v.field === 'realBidPrice' ||
            v.field === 'auctionPrice' ||
            v.field === 'profit' ||
            v.field === 'winPrice' ||
            v.field === 'cpcPrice' ||
            v.field === 'reportTime' ||
            v.field === 'effectiveResSmt'
          "
          :label="v.title"
          :width="v.width"
          :min-width="v.minWidth"
          :key="i"
        >
          <template v-slot="scope">
            <el-tag
              v-if="
                v.field === 'deeplinkNumberProportion' ||
                v.field === 'timeoutNumberProportion'
              "
              type="info"
              >{{ scope.row[v.field] }}</el-tag
            >
            <el-tag
              v-else-if="
                v.field === 'showRat' ||
                v.field === 'clickRate' ||
                v.field === 'dpRate' ||
                v.field === 'fillingRate' ||
                v.field === 'effectiveFillingRate' ||
                v.field === 'effectiveShowRat' ||
                v.field === 'bidRate'
              "
              type="info"
              >{{ scope.row[v.field] }}%</el-tag
            >

            <span v-else style="display: inline-block">{{
              scope.row[v.field]
            }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :page-sizes="[10, 30, 60, 100, 200]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px"
      />
    </div>
  </div>
</template>

<script>
import DateFormatSelect from "@/components/DateFormatSelect";
import SearchChannelSelect from "@/components/SearchChannelSelect";
import SearchDspSlotSelect from "@/components/SearchDspSlotSelect";
import SearchDspSelect from "@/components/SearchDspSelect";
import SearchChannelSlotSelect from "@/components/SearchChannelSlotSelect";
import SearchSlotTypeSelect from "@/components/SearchSlotTypeSelect";
import BaseDatePicker from "@/components/BaseDatePicker";
import TableColumn from "@/components/TableColumn";
import SearchBudgetType from "@/components/SearchBudgetType";
import initTableMixin from "@/mixins/initTable";
import downExcelMixin from "@/mixins/downExcel";

import { uuid } from "@/util/util";

export default {
  name: "ReportAppBundle",
  components: {
    DateFormatSelect,
    SearchChannelSelect,
    SearchDspSelect,
    SearchDspSlotSelect,
    SearchChannelSlotSelect,
    SearchSlotTypeSelect,
    BaseDatePicker,
    TableColumn,
    SearchBudgetType
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      columns: [
        { field: "channelName", title: "渠道名称" },
        { field: "slotId", title: "广告位编号" },
        { field: "slotName", title: "广告位名称" },
        { field: "appName", title: "应用名" },
        { field: "appBundle", title: "包名" },
        { field: 'dspName', title: 'DSP名称' },
        { field: "dspSlotName", title: "DSP广告位" },
        { field: "realReq", title: "包名总请求" },
        { field: "reqSmt", title: "请求数" },
        { field: "resSmt", title: "填充数" },
        { field: "effectiveResSmt", title: "有效填充" },
        { field: "fillingRate", title: "填充率" },
        { field: "effectiveFillingRate", title: "有效填充率" },
        { field: "uniShowSmt", title: "展示数" },
        { field: "showRat", title: "展示率" },
        { field: "effectiveShowRat", title: "有效展示率" },
        { field: "uniClkSmt", title: "点击数" },
        { field: "clickRate", title: "点击率" },
        { field: "deeplinkNumberProportion", title: "dp填充率" },
        // { field: "timeoutNumberProportion", title: "超时率" },
        { field: "dpRate", title: "dp唤起率" },
        // { field: "cpcPrice", title: "CPC单价" },
        { field: "auctionPrice", title: "支出" },
        { field: "channelEcpm", title: "支出ecpm" },
        { field: "winPrice", title: "收入" },
        { field: "ecpmAverage", title: "收入ecpm" },
        // { field: "originalWinPrice", title: "原始收入" },
        { field: "profit", title: "利润" },
        // { field: "time", title: "时长(毫秒)" },
        { field: "dpSmt", title: "唤起数" },
        // { field: "uniWinSmt", title: "竞得数" },
        // { field: "bidRate", title: "竞得率" },
      ],
      hides: [
      ],
      listData: [],
      slotIdList: [],
      dspSlotIdList: [],
      selectionColumn: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    beforeInit() {
      this.tableUrl = "/report/appbundle/list";
      this.tableParams.pageNum = this.pagination.pageNum;
      this.tableParams.pageSize = this.pagination.pageSize;
      return true;
    },
    sizeChange(e) {
      this.pagination.pageSize = e;
      this.tableParams.pageSize = e;
      this.init();
    },
    currentChange(e) {
      this.pagination.pageNum = e;
      this.tableParams.pageNum = e;
      this.init();
    },
    toQuery() {
      if (this.slotIdList) {
        this.tableParams.slotIdList = this.slotIdList.join(",");
      }
      if (this.dspSlotIdList) {
        this.tableParams.dspSlotIdList = this.dspSlotIdList.join(",");
      }
      this.init();
    },
    changeDate(date) {
      this.tableParams.startTime = date.startTime;
      this.tableParams.endTime = date.endTime;
    },
    changeChartDate(date) {
      this.chartParam.startTime = date.startTime;
      this.chartParam.endTime = date.endTime;

      const search = {
        slotId: this.chartParam.slotId,
        desc: "reportTime",
        startTime:date.startTime,
        endTime:date.endTime,
      };
      getDspEchartTimeReportList(search).then(res => {
        if (res.code === 200) {
          this.listData = res.data
        }
      })
    },
    changeChartTimeRadio() {
      let end = new Date()
      let start = new Date()
      if (this.chartTimeRadio === '昨天') {
        start.setTime(start.getTime() - 3600 * 1000 * 24)
        end.setTime(end.getTime() - 3600 * 1000 * 24)
      } else if (this.chartTimeRadio === '最近7天') {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
      } else if (this.chartTimeRadio === '最近30天') {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 29)
      } else if (this.chartTimeRadio === '本月') {
        const date = new Date()
        start = new Date(new Date().getFullYear(), new Date().getMonth(), 1)
        const day = new Date(date.getFullYear(), date.getMonth(), 0).getDate()
        end = new Date(new Date().getFullYear(), new Date().getMonth(), day)
      } else if (this.chartTimeRadio === '上月') {
        const date = new Date()
        start = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
        const day = new Date(date.getFullYear(), date.getMonth(), 0).getDate()
        end = new Date(new Date().getFullYear(), new Date().getMonth() - 1, day)
      }
      this.chartParam.defaultDate = [start, end]
    },
    changeDateFormatData(dateFormatId) {
      this.dateFormatId = dateFormatId;
      this.tableParams.isDay = null;
      this.tableParams.isHour = null;
      this.tableParams.isMonth = null;
      if (dateFormatId === 0) {
        this.tableParams.desc = "";
      } else if (dateFormatId === 1) {
        this.tableParams.isDay = 1;
        this.tableParams.desc = "reportTime";
      } else if (dateFormatId === 2) {
        this.tableParams.isHour = 1;
        this.tableParams.desc = "reportTime";
      } else if (dateFormatId === 3) {
        this.tableParams.isMonth = 1;
        this.tableParams.desc = "reportTime";
      }
      this.tableParams.asc = "";
    },
    sortChange(column, prop, order) {
      if (column.order === "ascending") {
        this.tableParams.asc = column.prop;
        this.tableParams.desc = "";
      } else if (column.order === "descending") {
        this.tableParams.desc = column.prop;
        this.tableParams.asc = "";
      }
      this.init();
    },
    selectionChange(selection) {
      this.selectionColumn = selection;
    },
    tableSummary(row) {
      const arr = [
        "uniShowSmt",
        "uniClkSmt",
        "reqSmt",
        "realReq",
        "resSmt",
        "dpSmt",
        "dauSlotReqSmt",
        "uniWinSmt",
        "bidPrice",
        "basePrice",
        "bidDspPrice",
        "realBidPrice",
      ];
      const fixedArr = ["auctionPrice", "winPrice", "profit"];
      const fixed2Arr = [
        "channelEcpm",
        "ecpmAverage",
        "fillingRate",
        "showRat",
        "clickRate",
        "dpRate",
        "bidRate",
      ];
      const { data } = row;
      const checklists = this.checkColumns.map((item) => {
        return item.field;
      });
      const out = [];
      debugger
      for (let i = 0; i < checklists.length; i++) {
        if (i === 0) {
          out[i] = "合计";
        } else {
          if (fixedArr.indexOf(checklists[i]) > -1) {
            out[i] = data
              .reduce((total, item) => {
                return total + Number(item[checklists[i]]);
              }, 0)
              .toFixed(4);
          } else if (fixed2Arr.indexOf(checklists[i]) > -1) {
            switch (checklists[i]) {
              case "channelEcpm":
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.auctionPrice);
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniShowSmt);
                    }, 0)) *
                  1000
                ).toFixed(4);
                break;
              case "ecpmAverage":
                out[i] = (
                  (data
                    .reduce((total, item) => {
                      return total + Number(item.winPrice);
                    }, 0)
                    .toFixed(4) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniShowSmt);
                    }, 0)) *
                  1000
                ).toFixed(2);
                break;
              case "fillingRate":
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.resSmt);
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.reqSmt);
                    }, 0)) *
                  100
                ).toFixed(2);
                break;
              case "showRat":
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.uniShowSmt);
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.resSmt);
                    }, 0)) *
                  100
                ).toFixed(2);
                break;
              case "clickRate":
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.uniClkSmt);
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniShowSmt);
                    }, 0)) *
                  100
                ).toFixed(2);
                break;
              case "dpRate":
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.dpSmt);
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.uniClkSmt);
                    }, 0)) *
                  100
                ).toFixed(2);
                break;
              case "bidRate":
                out[i] = (
                  (data.reduce((total, item) => {
                    return total + Number(item.uniWinSmt);
                  }, 0) /
                    data.reduce((total, item) => {
                      return total + Number(item.resSmt);
                    }, 0)) *
                  100
                ).toFixed(2);
                break;
            }
          } else {
            out[i] =
              arr.indexOf(checklists[i]) > -1
                ? data.reduce((total, item) => {
                    return total + Number(item[checklists[i]]);
                  }, 0)
                : "-";
          }
        }
      }
      return out;
    }
  },
};
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}

::v-deep.el-table__placeholder {
  display: none;
}

::v-deep.el-table__expand-icon {
  width: auto !important;
}

// /deep/.el-table__footer-wrapper tbody td{
//   border-bottom: none;
//   .cell{
//   overflow: hidden;
//   text-overflow: ellipsis;
//   word-break:normal
//   }
// }
// /deep/.el-table__fixed-footer-wrapper tbody td{
//   border-bottom: none;
//   .cell{
//       word-break:normal;
//   }
// }
// /deep/.el-table__fixed-header-wrapper .cell{
//   width: 70px;
// }
// /deep/.el-table__body-wrapper {
//   order: 0;
// }
</style>
